import React from 'react';

/**
 * Distinctive amber callout for expert trap warnings.
 * Used in exam ReviewMode for questions where deep experience misleads.
 */
export default function ExpertTrapBadge({ warning, className = '' }) {
  if (!warning) return null;

  return (
    <div className={`bg-amber-50 border-2 border-amber-400 rounded-xl p-5 ${className}`}>
      <div className="flex items-start gap-3">
        <div className="text-2xl shrink-0">⚠️</div>
        <div>
          <h4 className="text-amber-800 font-bold text-sm uppercase tracking-wider mb-2">
            Expert Trap
          </h4>
          <p className="text-amber-900 text-sm leading-relaxed">{warning}</p>
          <p className="text-amber-600 text-xs mt-2 italic">
            This question catches experienced engineers. The exam wants the textbook answer, not the real-world approach.
          </p>
        </div>
      </div>
    </div>
  );
}
